// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_RMX","cls2":"shared-cls2_zEz shared-cls1_RMX"};